import { computed, Injectable, signal } from '@angular/core'

import { environment } from '@env'
import { OperatorData } from '@definitions/operator-data'
import { decrypter } from '@utils/decryptor'
import { ProdOperatorsEnum } from '@enums/prod-operators-enum'
import { ProdLocationsEnum } from '@enums/prod-locations-enum'

@Injectable({
	providedIn: 'root',
})
export class OperatorDataState {
	readonly operatorData = signal<OperatorData | null>(null)
	readonly isAuthed = computed(() => Boolean(this.operatorData()))
	readonly metadata = computed(() => {
		const operatorData = this.operatorData()

		if (!operatorData) return null

		return operatorData.metadata
	})
	readonly firebaseUser = computed(() => {
		const operatorData = this.operatorData()

		if (!operatorData) return null

		const { firebaseUser: encryptedUser, firebasePsw: encryptedPsw } = this.metadata()

		const user = decrypter(encryptedUser)
		const password = decrypter(encryptedPsw)

		return { user, password }
	})
	readonly isCurbstand = computed(() => {
		const metadata = this.metadata()

		if (!environment.production || !metadata) return false

		const { operatorCompanyId, parkingLocationId } = metadata
		const isProdCurbstand = operatorCompanyId === ProdOperatorsEnum.Curbstand
		const isProdMaybourneBeverlyHills =
			parkingLocationId === ProdLocationsEnum.MaybourneBeverlyHills

		return isProdCurbstand && isProdMaybourneBeverlyHills
	})
}
